import * as React from 'react';
import getAnimationStyle from '@utils/animation.utils';

const LoadingSpinner: React.FC<
  React.PropsWithChildren<Record<string, never>>
  // @ts-ignore
> = () => <div style={getAnimationStyle()} />;

export default LoadingSpinner;
